// Events
export const SZ_REFERENCE_DATA =
  "sizotsaFuneralClaim/referenceData/";
export const SZ_BANK_REFERENCE_DATA_GET_VALUE =
SZ_REFERENCE_DATA+ "bankReferenceData/getValue/";
export const SZ_BRANCH_CODES_REFERENCE_DATA_GET_VALUE =
SZ_REFERENCE_DATA+"branchCodeReferenceData/getValue/";
export const SZ_BANK_REFERENCE_DATA_SET_VALUE =
SZ_REFERENCE_DATA+ "bankReferenceData/setValue/";
export const SZ_BRANCH_CODES_REFERENCE_DATA_SET_VALUE =
SZ_REFERENCE_DATA+"branchCodeReferenceData/setValue/";

export const getBankReferenceData = () => ({  
  type: SZ_BANK_REFERENCE_DATA_GET_VALUE,
});
export const getBranchCodeReferenceData = (value) => ({
  type: SZ_BRANCH_CODES_REFERENCE_DATA_GET_VALUE,
  value
});
export const setBankReferenceData = (value) => ({  
  type: SZ_BANK_REFERENCE_DATA_SET_VALUE,
  value
});
export const setBranchCodeReferenceData = (value) => ({
  type: SZ_BRANCH_CODES_REFERENCE_DATA_SET_VALUE,
  value
});

// Branch Code Data API status
export const SZ_BRANCH_CODES_REFERENCE_DATA_API_STATUS = SZ_REFERENCE_DATA + 'branchCodeReferenceData/setApiStatus';

export const setBranchCodesApiStatus = (value) => ({
    type: SZ_BRANCH_CODES_REFERENCE_DATA_API_STATUS,
    value
});

export const SZ_MAIL_SERVICE= "sizotsaFuneralClaim/callMailService/sendMail";
export const sendEmail = (value) => ({type:SZ_MAIL_SERVICE,value})

export const SZ_DOCUMENT_MAIL_SERVICE= "sizotsaFuneralClaim/uploadDocument/sendDocumentMail";
export const sendUploadDocument = () => ({type:SZ_DOCUMENT_MAIL_SERVICE})

export const SZ_SET_REF_NUMBER= "sizotsaFuneralClaim/setRefNumber/setRef";
export const setRefNumber = (value) => ({type:SZ_SET_REF_NUMBER,value})

export const RESET_REFERENCE_DATA =
  "sizotsaFuneralClaim/referenceData/setValue/resetState";
export const resetReferenceData = () => ({ type: RESET_REFERENCE_DATA });


